<div class="nsc-app-footer mat-caption" role="contentinfo">
  <img src="/assets/Nsc-Tree-Logo.svg" alt="National Student Clearinghouse logo" class="nsc-app-footer__logo--nsc" />
  <nsc-spacer size="sm"></nsc-spacer>
  <p class="mb-0">2300 Dulles Station Blvd. Suite 220 <br>  Herndon,VA 20171</p>
  <nsc-spacer size="sm"></nsc-spacer>
  <span id="footer_links_desc" class="cdk-visually-hidden" aria-hidden="true">opens in new window</span>
  <ul class="nsc-listitem">
    <li class="nsc-listitem__link-item">
      <a href="https://www.studentclearinghouse.org/contact" rel="noopener" target="_blank" aria-describedby="footer_links_desc">
        Contact Us</a><mat-icon aria-hidden="true">open_in_new</mat-icon>
    </li>

    <li class="nsc-listitem__link-item">
      <!--
        aria-label overrides the accessible name to "National Student Clearinghouse Privacy Policy"
        so it is unique from Clover's "Privacy Policy" link that also renders on /order/payment.
        Prevents Level Access / WCAG 2.4.4 Link purpose(In context) "duplicate link name, different href" violation.
      -->
      <a href="https://www.studentclearinghouse.org/privacy-policy/" rel="noopener" target="_blank" aria-label="National Student Clearinghouse Privacy Policy" aria-describedby="footer_links_desc">
        Privacy Policy</a><mat-icon aria-hidden="true">open_in_new</mat-icon>
    </li>

    <li class="nsc-listitem__link-item">
      <a href="https://www.studentclearinghouse.org/terms-of-use/" rel="noopener" target="_blank" aria-describedby="footer_links_desc">
        Terms & Conditions of Use</a><mat-icon aria-hidden="true">open_in_new</mat-icon>
    </li>
    <li>
      &copy;{{ copyrightYear }} <span class="nsc-listitem__link-item"><a href="https://www.studentclearinghouse.org/" rel="noopener" target="_blank" aria-describedby="footer_links_desc">
        National Student Clearinghouse</a><mat-icon aria-hidden="true">open_in_new</mat-icon>.</span> All Rights Reserved.
    </li>
  </ul>
</div>
